import React, { useState, useEffect } from 'react';
import { Download, FileText, Calendar } from 'lucide-react';
import Accordion from '../../components/Accordion/Accordion';
import './Documentos.css';

import Doc01 from '../../assets/documents/2025-11-27 - PRODUTO 1 - PLANEJAMENTO EXECUTIVO - VO.pdf';
import Doc02 from '../../assets/documents/2025-11-27 - PRODUTO 2 - VO.pdf';
import Doc03_1 from '../../assets/documents/2026-03-27 - PRODUTO 3.1 - VP.pdf';
import Doc03_2 from '../../assets/documents/2026-04-30 - PRODUTO 3.2 DIAGNOSTICO PARTICIPATIVO.pdf';
import Doc04 from '../../assets/documents/APRESENTAÇÃO_1AUDIENCIA.pdf';
import Doc04_1 from '../../assets/documents/2026-06-02 - Ata Audiência.pdf';
import Doc04_2 from '../../assets/documents/LISTA DE PRESENÇA ASSINADA.pdf';


const documents = [
  {
    id: 1,
    title: 'Planejamento Executivo V0 - Produto 01',
    description: 'Detalhadamento das etapas, metodologias e diretrizes que orientarão a elaboração do Plano Municipal de Saneamento Básico do município de Paraisópolis.',
    format: 'PDF',
    filePath: Doc01,
    updateMonth: ''
  },
  {
    id: 2,
    title: 'Plano de Comunicação V0 - Produto 02',
    description: 'Apresentação da metodologia e dos instrumentos concebidos para assegurar a participação efetiva da sociedade civil no processo de elaboração do Plano Municipal de Saneamento Básico do município de Paraisópolis.',
    format: 'PDF',
    filePath: Doc02,
    updateMonth: ''
  },

  {
    id: 3,
    title: 'Relatório 1: DiagnósticoTécnico - Produto 3.1',
    description: 'Apresentação da caracterização geográfica, ambiental, econômica e social do Município de Paraisópolis, assim como a análise participativa dos dados coletados junto a população.',
    format: 'PDF',
    filePath: Doc03_1,
    updateMonth: ''
  },
  {
    id: 4,
    title: 'Diagnóstico Participativo - Produto 3.2',
    description: 'Descrição dos procedimentos metodológicos adotados para a coleta, processamento e análise dos dados obtidos junto à população.',
    format: 'PDF',
    filePath: Doc03_2,
    updateMonth: ''
  },
  {
    id: 5,
    title: 'Apresentação 1ª Audiência Pública',
    description: 'Primeira Audiência Pública - Diagnóstico Técnico e Participativo.',
    format: 'PDF',
    filePath: '',
    updateMonth: 'Junho de 2026',
    subDocuments: [
      {
        id: '5-1',
        title: 'Apresentação da 1ª Audiência Pública',
        format: 'PDF',
        filePath: Doc04
      },
      {
        id: '5-2',
        title: 'Ata da 1ª Audiência Pública',
        format: 'PDF',
        filePath: Doc04_1
      },
      {
        id: '5-3',
        title: 'Lista de Presença Assinada',
        format: 'PDF',
        filePath: Doc04_2
      }
    ]
  }
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];
  return `${months[date.getMonth()]} de ${date.getFullYear()}`;
};

const resolveManualMonth = (manualMonth) => {
  if (!manualMonth || !manualMonth.trim()) {
    return null;
  }

  const sanitizedMonth = manualMonth.trim();
  const isoYearMonth = sanitizedMonth.match(/^(\d{4})-(\d{2})$/);

  if (isoYearMonth) {
    const [_, year, month] = isoYearMonth;
    return formatDate(`${year}-${month}-01`);
  }

  return sanitizedMonth;
};

const getDateFromFileName = (filePath) => {
  const filename = filePath.split('/').pop();
  const dateMatch = filename.match(/(\d{4}-\d{2}-\d{2})/);

  if (!dateMatch) {
    return 'Data não disponível';
  }

  return formatDate(dateMatch[1]);
};

const Documentos = () => {
  const [documentDates, setDocumentDates] = useState({});

  useEffect(() => {
    const fetchFileDates = async () => {
      const dates = {};

      for (const doc of documents) {
        const manualMonth = resolveManualMonth(doc.updateMonth);

        if (manualMonth) {
          dates[doc.id] = manualMonth;
          continue;
        }

        if (!doc.filePath) {
          dates[doc.id] = 'Data não disponível';
          continue;
        }

        try {
          const response = await fetch(doc.filePath, { method: 'HEAD' });
          const lastModified = response.headers.get('Last-Modified');

          if (lastModified) {
            dates[doc.id] = formatDate(lastModified);
          } else {
            dates[doc.id] = getDateFromFileName(doc.filePath);
          }
        } catch (error) {
          console.error(`Error fetching date for ${doc.filePath}:`, error);
          dates[doc.id] = getDateFromFileName(doc.filePath);
        }
      }

      setDocumentDates(dates);
    };

    fetchFileDates();
  }, []);

  const handleDownload = (filePath, fileName) => {
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName || filePath.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const accordionItems = documents.map((doc) => {
    const date = documentDates[doc.id] || 'Carregando...';
    const hasSubDocuments = Array.isArray(doc.subDocuments) && doc.subDocuments.length > 0;
    const hasPrimaryFile = Boolean(doc.filePath);

    return {
      title: doc.title,
      metadata: `Atualizado em ${date}`,
      leading: <FileText aria-hidden="true" />,
      content: (
        <div className="document-item">
          <p className="document-item__description">{doc.description}</p>

          {hasSubDocuments && (
            <div className="document-item__subdocuments">
              {doc.subDocuments.map((subDoc) => (
                <div key={subDoc.id} className="document-item__subdocument">
                  <div className="document-item__subdocument-info">
                    <FileText aria-hidden="true" className="document-item__subdocument-icon" />
                    <p className="document-item__subdocument-title">{subDoc.title}</p>
                  </div>

                  {subDoc.filePath && (
                    <button
                      type="button"
                      className="document-item__download document-item__download--sub"
                      onClick={() => handleDownload(subDoc.filePath, `${subDoc.title}.${subDoc.format.toLowerCase()}`)}
                    >
                      <Download aria-hidden="true" />
                      <span>Baixar</span>
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}

          <div className="document-item__footer">
            <div className="document-item__meta">
              {hasPrimaryFile && (
                <span className="document-item__badge document-item__badge--format">
                  <FileText aria-hidden="true" />
                  {doc.format}
                </span>
              )}
              <span className="document-item__badge document-item__badge--date">
                <Calendar aria-hidden="true" />
                {date}
              </span>
            </div>

            {hasPrimaryFile && (
              <button
                type="button"
                className="document-item__download"
                onClick={() => handleDownload(doc.filePath, `${doc.title}.${doc.format.toLowerCase()}`)}
              >
                <Download aria-hidden="true" />
                <span>Baixar</span>
              </button>
            )}
          </div>
        </div>
      )
    };
  });

  return (
    <div className="documents-page">
      <section className="page-hero">
        <div className="page-hero__text">
          <span className="page-hero__eyebrow">Documentos</span>
        </div>
      </section>

      <section className="documents-content">
        <div className="documents-intro">
          <p className="documents-intro__text">
            Consulte materiais tecnicos e registros oficiais que documentam o Plano Municipal de Saneamento Básico.
          </p>
        </div>

        {/* <div style={{
          textAlign: 'center',
          padding: '4rem 2rem',
          color: '#666',
          fontSize: '1.125rem'
        }}>
          <p>Por enquanto não há documentos disponíveis.</p>
          <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
            Em breve, você encontrará aqui documentos técnicos e registros oficiais do PMSB.
          </p>
        </div> */}

        <div className="documents-accordion">
          <Accordion items={accordionItems} />
        </div>
      </section>
    </div>
  );
};

export default Documentos;
